import {
  barcodeMethod
} from './prototype-barcode.js';
import {
  isValueEmpty,
  remove_ie_header_and_footer
} from '@/utils';

export function initLabelFrame({iframe, partNo, lotNo, qty, trackingNo, dateCode, packageType, result, marking, grossWeight, netWeight, binLevelExplain, remark}) {
  let PN = partNo;
  let LOTNO = lotNo;
  let QTY = qty;
  let TrayNo = trackingNo;
  let DateCode = dateCode;
  let Marking = marking;
  let isBoxLabel = netWeight !== null && grossWeight !== null
    && netWeight !== undefined && grossWeight !== undefined
    && netWeight !== '' && grossWeight !== '';
  let binLevel = binLevelExplain || '';

  let doc = iframe.contentWindow.document;
  let titleFontFamily = 'Microsoft YaHei, SimHei';
  let contentFontFamily = 'Microsoft YaHei, SimHei';
  let grossWeightText = '', netWeightText = '';
  if (!isValueEmpty(grossWeight)) {
    console.warn(grossWeight);
    let gross = Number.parseFloat(grossWeight);
    if (gross < 10) { //小数点前后都要保留两位小数，不够补0
      grossWeightText = '0' + gross.toFixed(2);
    } else {
      grossWeightText = gross.toFixed(2);
    }
  }
  if (!isValueEmpty(grossWeight)) {
    let net = Number.parseFloat(netWeight);
    if (net < 10) {
      netWeightText = '0' + net.toFixed(2);
    } else {
      netWeightText = net.toFixed(2);
    }
  }
  doc.writeln(`
        <html>
        <head>
            <style type="text/css" media="print">
                @page {
                    size: auto;
                    margin: 0mm;
                }
            </style>
            <style type="text/css">
                * {
                    margin: 0;
                    padding: 0;
                }
                .container {
                    border: 1px solid #000;
                    width: calc(100% - 20px);
                    box-sizing: border-box;
                    position: absolute;
                    height: calc(100% - 20px);
                    top: 0;
                    left: 10px;
                }
                .left-title {
                    margin-left: 10px;
                    margin-top: 1px;
                    margin-bottom: 2px;
                    font-family: ${titleFontFamily};
                }
                .right-title {
                    margin-left: 10px;
                    margin-top: 1px;
                    margin-bottom: 2px;
                    font-family: ${titleFontFamily};
                }
                .fontSize15 {
                    font-size: 15px;
                }
                .fontSize13 {
                    font-size: 14px;
                    zoom: 0.9;
                }
                .fontSize12 {
                    font-size: 12px;
                    zoom: 0.9;
                }
                .fontSize10 {
                    font-size: 12px;
                    zoom: 0.8;
                }
                .fontSize7 {
                    font-size: 12px;
                    zoom: 0.7;
                }
                .boldText {
                    font-weight: bold;
                }
                .left-barcode-container {
                    margin-left: 8px;
                }
                .right-barcode-container {
                    margin-left: 6px;
                }
                .content-title {
                    margin: -1px 0 0 6px;
                    font-family: ${contentFontFamily};
                }
                .passed {
                    font-size: 12px;
                    zoom: 0.7;
                    margin-right: 10px;
                    border: 1px solid #000;
                    border-radius: 50% / 50%;
                    padding: 5px 7px;
                    display: inline-block;
                    font-family: ${titleFontFamily},serif;
                }
                .underlineText {
                    border-bottom: 1px solid #000;
                }
            </style>
        </head>
            <body>
                <div class="container">
                    <div style="left: 0; position: absolute; top: 0; z-index: 100; width: 100%; height: 100%;">
                        <p class="left-title boldText fontSize13">P/N:${PN}</p>
                        <div id="PN" class="left-barcode-container"></div>
                        <p class="left-title boldText fontSize12">LOT NO:${LOTNO}</p>
                        <div id="LOTNO" class="left-barcode-container"></div>
                        <div style="display: flex; flex-direction: row; position: relative;">
                            <div>
                                <p class="left-title boldText fontSize12">QTY:${QTY}</p>
                                <div id="QTY" class="left-barcode-container"></div>
                            </div>
                            <div style="position: absolute; left: 39%; top: 5px;">
                                <span class="passed boldText">${result ? 'PASSED' : 'FAILED'}</span>
                            </div>
                        </div>
                        <p class="left-title fontSize12 boldText">Tracking NO:${TrayNo}</p>
                        <div id="TrayNo" class="left-barcode-container"></div>
                    </div>
                    <div style="left: 59%; top: 8%; z-index: 1; position: absolute;">
                        ${remark ? `<p class="right-title boldText fontSize12">${remark}</p>` : ''}
                    </div>
                    <div style="left: 59%; top: 20%; z-index: 1; position: absolute;">
                        <p class="right-title boldText fontSize10">Date Code:${DateCode}</p>
                        <div id="DateCode" class="right-barcode-container"></div>
                        <p class="content-title"><span class="fontSize7 boldText underlineText">Halogen Free</span></p>
                        <p class="content-title"><span class="fontSize7 boldText">Package:${packageType || ''}</span></p>
                        <p class="content-title"><span class="fontSize7 boldText">Marking:${Marking}</span></p>
                        <p class="content-title"><span class="fontSize7 boldText">Country of Origin China</span></p>
                        ${isBoxLabel ? `<p class="content-title"><span class="fontSize7 boldText">N.W./G.W.:${netWeightText} Kg/${grossWeightText} Kg</span></p>` : ''}
                    </div>
                    <span class="fontSize15 boldText" style="font-family: ${titleFontFamily}; top: 5px; right: 15%; z-index: 1; position: absolute;">${binLevel}</span>
                </div>
            </body>
        </html>
        `
  );

  const settings = {
    output: 'bmp',
    bgColor: '#FFFFFF',
    color: '#000000',
    barWidth: 1,
    barHeight: 20,
    moduleSize: 5,
    posX: 1,
    posY: 0.1,
    addQuietZone: false,
    showHRI: false,
  };
  const type = 'code128';

  const viewPN = doc.getElementById('PN');
  barcodeMethod.barcode(viewPN, PN, type, settings);

  const viewLOTNO = doc.getElementById('LOTNO');
  barcodeMethod.barcode(viewLOTNO, LOTNO, type, settings);

  const viewQTY = doc.getElementById('QTY');
  barcodeMethod.barcode(viewQTY, QTY + '', type, settings);

  const viewTrayNo = doc.getElementById('TrayNo');
  barcodeMethod.barcode(viewTrayNo, TrayNo, type, settings);

  const viewDateCode = doc.getElementById('DateCode');
  barcodeMethod.barcode(viewDateCode, DateCode, type, settings);

  doc.close();
  return iframe;
}

export function initBoxLabelFrame({iframe, partNo, lotNo, qty, trackingNo, dateCode, packageType, result, marking, grossWeight, netWeight, binLevelExplain}) {
  return initLabelFrame({
    iframe,
    partNo,
    lotNo,
    qty,
    trackingNo,
    dateCode,
    packageType,
    result,
    marking,
    grossWeight,
    netWeight,
    binLevelExplain
  });
}

// LS9929CS/B1101 右上角档位 1不显示，2 3 4分别显示BIN2 BIN3 BIN4
function isNeedPrintBinLevelNO({productName, partNo, chipName}) {
  const isLS9929CS = productName === 'LS9929CS' || (partNo === 'LS9929CS' || partNo === 'LS9929CSTR');
  let isNeedPrintBinLevel = false;
  if (isLS9929CS) {
    if (chipName === 'B1101') {
      isNeedPrintBinLevel = true;
    }
  }
  return isNeedPrintBinLevel;
}

// LS9929S 全部显示档位 A B C
// LS9930S B0A07 全部显示档位 A B C
// LS9930S A9804 A9804B 3 4显示档位 B C 1 2不展示
// LS9935S 全部显示档位 A B C
function isNeedPrintBinLevel({productName, partNo, chipName, binLevel}) {
  const isLS9929S = productName === 'LS9929S' || (partNo === 'LS9929S' || partNo === 'LS9929STR');
  const isLS9930S = productName === 'LS9930S' || (partNo === 'LS9930S' || partNo === 'LS9930STR');
  const isLS9935S = productName === 'LS9935S' || (partNo === 'LS9935S' || partNo === 'LS9935STR');
  let isNeedPrintBinLevel = false;
  if (isLS9929S) {
    isNeedPrintBinLevel = true;
  }
  if (isLS9930S) {
    if (chipName === 'B0A07') {
      isNeedPrintBinLevel = true;
    }
    if(chipName === 'A9804' || chipName === 'A9804B'){
      const bin = Number.parseInt(binLevel, 10);
      if(bin === 3 || bin === 4){
        isNeedPrintBinLevel = true;
      }
    }
  }
  if (isLS9935S) {
    isNeedPrintBinLevel = true;
  }
  return isNeedPrintBinLevel;
}

export function generateBinLevelValue({productName, partNo, chipName, binLevel}) {
  let binLevelValue = '';
  const bin = Number.parseInt(binLevel, 10);
  if (isNeedPrintBinLevelNO({productName, partNo, chipName})) {
    if (bin === 1) {
      binLevelValue = '';
    } else {
      binLevelValue = 'BIN' + bin;
    }
  } else if (isNeedPrintBinLevel({productName, partNo, chipName, binLevel})) {
    if (bin === 3) {
      binLevelValue = 'B';
    } else if (bin === 4) {
      binLevelValue = 'C';
    } else if (bin === 1 || bin === 2) {
      binLevelValue = 'A';
    }
  }
  return binLevelValue;
}

export function printLabel({partNo, lotNo, qty, trackingNo, dateCode, packageType, result, marking, grossWeight, netWeight, binLevelExplain, explain}) {
  let iframe = document.createElement('iframe');
  iframe.style.display = 'none';
  document.body.appendChild(iframe);
  iframe = initLabelFrame({iframe, partNo, lotNo, qty, trackingNo, dateCode, packageType, result, grossWeight, netWeight, marking, binLevelExplain, remark: explain});
  setTimeout(() => {
    if (!!window.ActiveXObject || "ActiveXObject" in window) { //是否ie
      remove_ie_header_and_footer();
    }
    iframe.contentWindow.focus();
    iframe.contentWindow.print();
    document.body.removeChild(iframe);
    iframe = null;
  }, 200);
}
